/* esm.sh - canvg@4.0.3 */
import "/node/process.mjs";
export * from "/*canvg@4.0.3/esnext/canvg.mjs";
